// Generated by scripts/build-fit-advisor.mjs. Edit the source files.
// src/data/size-calculator-data.js
/**
 * Authoritative trouser-size data exported from Shopify size metaobjects.
 *
 * Source: Export_2026-07-24_133533.xlsx
 * Included records: 93
 *
 * Keep the source values unchanged. Matching and display normalization
 * should be handled by the calculator logic, not by editing this dataset.
 */

const sizeCalculatorData = Object.freeze([
  Object.freeze({
    metaobjectId: '98855125290',
    handle: '29-32',
    displayName: '29/32',
    deValues: Object.freeze([]),
    inchValues: Object.freeze(['29/32']),
    waist: 75,
    insideLeg: 81.5,
    belt: Object.freeze({
      cm: '85',
      inch: '32',
    }),
    frEsValues: Object.freeze([]),
  }),
  Object.freeze({
    metaobjectId: '98855452970',
    handle: '44',
    displayName: '44',
    deValues: Object.freeze(['44']),
    inchValues: Object.freeze(['30/30']),
    waist: 77,
    insideLeg: 79,
    belt: Object.freeze({
      cm: '85',
      inch: '32',
    }),
    frEsValues: Object.freeze([]),
  }),
  Object.freeze({
    metaobjectId: '98877604138',
    handle: '30-30',
    displayName: '30/30',
    deValues: Object.freeze([]),
    inchValues: Object.freeze(['30/30']),
    waist: 78,
    insideLeg: 76.5,
    belt: Object.freeze({
      cm: '85',
      inch: '32',
    }),
    frEsValues: Object.freeze(['40/92']),
  }),
  Object.freeze({
    metaobjectId: '96072991018',
    handle: '31-32',
    displayName: '31/32',
    deValues: Object.freeze(['46']),
    inchValues: Object.freeze(['31/32']),
    waist: 80,
    insideLeg: 81,
    belt: Object.freeze({
      cm: '85',
      inch: '32',
    }),
    frEsValues: Object.freeze([]),
  }),
  Object.freeze({
    metaobjectId: '96052707626',
    handle: '46',
    displayName: '46',
    deValues: Object.freeze(['46']),
    inchValues: Object.freeze(['30/32 | 31/32']),
    waist: 81,
    insideLeg: 81,
    belt: Object.freeze({
      cm: '80',
      inch: '30',
    }),
    frEsValues: Object.freeze(['40/92']),
  }),
  Object.freeze({
    metaobjectId: '98877636906',
    handle: '30-32',
    displayName: '30/32',
    deValues: Object.freeze(['46']),
    inchValues: Object.freeze(['30/32']),
    waist: 81,
    insideLeg: 81.5,
    belt: Object.freeze({
      cm: '85',
      inch: '32',
    }),
    frEsValues: Object.freeze(['40/92']),
  }),
  Object.freeze({
    metaobjectId: '136422064426',
    handle: '30-34',
    displayName: '30/34',
    deValues: Object.freeze(['94']),
    inchValues: Object.freeze(['30/34']),
    waist: 81,
    insideLeg: 86.5,
    belt: Object.freeze({
      cm: '85',
      inch: '32',
    }),
    frEsValues: Object.freeze(['40/92']),
  }),
  Object.freeze({
    metaobjectId: '96070959402',
    handle: '32-30',
    displayName: '32/30',
    deValues: Object.freeze(['23']),
    inchValues: Object.freeze(['32/30']),
    waist: 83,
    insideLeg: 76,
    belt: Object.freeze({
      cm: '85',
      inch: '32',
    }),
    frEsValues: Object.freeze(['42C']),
  }),
  Object.freeze({
    metaobjectId: '96073089322',
    handle: '32-32',
    displayName: '32/32',
    deValues: Object.freeze(['48']),
    inchValues: Object.freeze(['32/32']),
    waist: 83,
    insideLeg: 81,
    belt: Object.freeze({
      cm: '85',
      inch: '32',
    }),
    frEsValues: Object.freeze(['42']),
  }),
  Object.freeze({
    metaobjectId: '96693027114',
    handle: '32-34',
    displayName: '32/34',
    deValues: Object.freeze(['94']),
    inchValues: Object.freeze(['32/34']),
    waist: 83,
    insideLeg: 86,
    belt: Object.freeze({
      cm: '85',
      inch: '32',
    }),
    frEsValues: Object.freeze(['42']),
  }),
  Object.freeze({
    metaobjectId: '132387307818',
    handle: '31-34',
    displayName: '31/34',
    deValues: Object.freeze(['94']),
    inchValues: Object.freeze(['31/34']),
    waist: 83,
    insideLeg: 86.5,
    belt: Object.freeze({
      cm: '85',
      inch: '32',
    }),
    frEsValues: Object.freeze(['42/92']),
  }),
  Object.freeze({
    metaobjectId: '95967445290',
    handle: '94',
    displayName: '94',
    deValues: Object.freeze(['94']),
    inchValues: Object.freeze(['32/34']),
    waist: 83,
    insideLeg: 86.5,
    belt: Object.freeze({
      cm: '85',
      inch: '32',
    }),
    frEsValues: Object.freeze(['40/92']),
  }),
  Object.freeze({
    metaobjectId: '132388946218',
    handle: '31-36',
    displayName: '31/36',
    deValues: Object.freeze([]),
    inchValues: Object.freeze(['31/36']),
    waist: 83,
    insideLeg: 91.5,
    belt: Object.freeze({
      cm: '85',
      inch: '32',
    }),
    frEsValues: Object.freeze(['42/92']),
  }),
  Object.freeze({
    metaobjectId: '98877702442',
    handle: '32-36',
    displayName: '32/36',
    deValues: Object.freeze(['98 · 102']),
    inchValues: Object.freeze(['32/36']),
    waist: 83,
    insideLeg: 91.5,
    belt: Object.freeze({
      cm: '85',
      inch: '32',
    }),
    frEsValues: Object.freeze(['42/92-44/92']),
  }),
  Object.freeze({
    metaobjectId: '96049627434',
    handle: '23',
    displayName: '23',
    deValues: Object.freeze(['23']),
    inchValues: Object.freeze(['32/30']),
    waist: 85,
    insideLeg: 75,
    belt: Object.freeze({
      cm: '90',
      inch: '34',
    }),
    frEsValues: Object.freeze(['42C']),
  }),
  Object.freeze({
    metaobjectId: '96072106282',
    handle: '33-30',
    displayName: '33/30',
    deValues: Object.freeze(['23']),
    inchValues: Object.freeze(['33/30']),
    waist: 85,
    insideLeg: 76,
    belt: Object.freeze({
      cm: '90',
      inch: '34',
    }),
    frEsValues: Object.freeze([]),
  }),
  Object.freeze({
    metaobjectId: '96073187626',
    handle: '33-32',
    displayName: '33/32',
    deValues: Object.freeze(['48 • 50']),
    inchValues: Object.freeze(['33/32']),
    waist: 85,
    insideLeg: 81,
    belt: Object.freeze({
      cm: '90',
      inch: '34',
    }),
    frEsValues: Object.freeze([]),
  }),
  Object.freeze({
    metaobjectId: '96053002538',
    handle: '48',
    displayName: '48',
    deValues: Object.freeze(['48']),
    inchValues: Object.freeze(['32/32']),
    waist: 85,
    insideLeg: 82,
    belt: Object.freeze({
      cm: '90',
      inch: '34',
    }),
    frEsValues: Object.freeze(['42']),
  }),
  Object.freeze({
    metaobjectId: '96656064810',
    handle: '33-34',
    displayName: '33/34',
    deValues: Object.freeze(['98']),
    inchValues: Object.freeze(['33/34']),
    waist: 85,
    insideLeg: 86,
    belt: Object.freeze({
      cm: '90',
      inch: '34',
    }),
    frEsValues: Object.freeze(['50/92']),
  }),
  Object.freeze({
    metaobjectId: '96692797738',
    handle: '33-36',
    displayName: '33/36',
    deValues: Object.freeze(['94']),
    inchValues: Object.freeze(['33/36']),
    waist: 85,
    insideLeg: 91,
    belt: Object.freeze({
      cm: '90',
      inch: '34',
    }),
    frEsValues: Object.freeze([]),
  }),
  Object.freeze({
    metaobjectId: '95969968426',
    handle: '98',
    displayName: '98',
    deValues: Object.freeze(['98']),
    inchValues: Object.freeze(['34/34']),
    waist: 87,
    insideLeg: 89,
    belt: Object.freeze({
      cm: '90',
      inch: '34',
    }),
    frEsValues: Object.freeze(['44']),
  }),
  Object.freeze({
    metaobjectId: '96072171818',
    handle: '34-30',
    displayName: '34/30',
    deValues: Object.freeze(['24']),
    inchValues: Object.freeze(['34/30']),
    waist: 88,
    insideLeg: 78,
    belt: Object.freeze({
      cm: '90',
      inch: '34',
    }),
    frEsValues: Object.freeze(['44C']),
  }),
  Object.freeze({
    metaobjectId: '96073220394',
    handle: '34-32',
    displayName: '34/32',
    deValues: Object.freeze(['50']),
    inchValues: Object.freeze(['34/32']),
    waist: 88,
    insideLeg: 81,
    belt: Object.freeze({
      cm: '90',
      inch: '34',
    }),
    frEsValues: Object.freeze(['44']),
  }),
  Object.freeze({
    metaobjectId: '96692994346',
    handle: '34-34',
    displayName: '34/34',
    deValues: Object.freeze(['98 • 50']),
    inchValues: Object.freeze(['34/34']),
    waist: 88,
    insideLeg: 86,
    belt: Object.freeze({
      cm: '90',
      inch: '34',
    }),
    frEsValues: Object.freeze(['44']),
  }),
  Object.freeze({
    metaobjectId: '96692732202',
    handle: '34-36',
    displayName: '34/36',
    deValues: Object.freeze(['98']),
    inchValues: Object.freeze(['34/36']),
    waist: 88,
    insideLeg: 91,
    belt: Object.freeze({
      cm: '90',
      inch: '34',
    }),
    frEsValues: Object.freeze(['44']),
  }),
  Object.freeze({
    metaobjectId: '96049725738',
    handle: '24',
    displayName: '24',
    deValues: Object.freeze(['24']),
    inchValues: Object.freeze(['34/30']),
    waist: 89,
    insideLeg: 77,
    belt: Object.freeze({
      cm: '95',
      inch: '36',
    }),
    frEsValues: Object.freeze(['44C']),
  }),
  Object.freeze({
    metaobjectId: '96695550250',
    handle: '50-x',
    displayName: '50X',
    deValues: Object.freeze(['50X']),
    inchValues: Object.freeze(['35/32']),
    waist: 89,
    insideLeg: 81,
    belt: Object.freeze({
      cm: '95',
      inch: '36',
    }),
    frEsValues: Object.freeze(['44/92']),
  }),
  Object.freeze({
    metaobjectId: '96053133610',
    handle: '50',
    displayName: '50',
    deValues: Object.freeze(['50']),
    inchValues: Object.freeze(['34/32']),
    waist: 89,
    insideLeg: 83,
    belt: Object.freeze({
      cm: '95',
      inch: '36',
    }),
    frEsValues: Object.freeze(['44']),
  }),
  Object.freeze({
    metaobjectId: '98703409450',
    handle: '24-5',
    displayName: '24.5',
    deValues: Object.freeze(['24.5']),
    inchValues: Object.freeze(['35/30']),
    waist: 90,
    insideLeg: 74,
    belt: Object.freeze({
      cm: '95',
      inch: '36',
    }),
    frEsValues: Object.freeze(['44c/92']),
  }),
  Object.freeze({
    metaobjectId: '96072597802',
    handle: '35-30',
    displayName: '35/30',
    deValues: Object.freeze(['24']),
    inchValues: Object.freeze(['35/30']),
    waist: 90,
    insideLeg: 76,
    belt: Object.freeze({
      cm: '95',
      inch: '36',
    }),
    frEsValues: Object.freeze(['44c/92']),
  }),
  Object.freeze({
    metaobjectId: '96073482538',
    handle: '35-32',
    displayName: '35/32',
    deValues: Object.freeze(['50 • 52']),
    inchValues: Object.freeze(['35/32']),
    waist: 90,
    insideLeg: 81,
    belt: Object.freeze({
      cm: '95',
      inch: '36',
    }),
    frEsValues: Object.freeze(['44/92']),
  }),
  Object.freeze({
    metaobjectId: '96692961578',
    handle: '35-34',
    displayName: '35/34',
    deValues: Object.freeze(['102']),
    inchValues: Object.freeze(['35/34']),
    waist: 90,
    insideLeg: 86,
    belt: Object.freeze({
      cm: '95',
      inch: '36',
    }),
    frEsValues: Object.freeze([]),
  }),
  Object.freeze({
    metaobjectId: '98877735210',
    handle: '35-36',
    displayName: '35/36',
    deValues: Object.freeze([]),
    inchValues: Object.freeze(['35/36']),
    waist: 90,
    insideLeg: 91.5,
    belt: Object.freeze({
      cm: '95',
      inch: '36',
    }),
    frEsValues: Object.freeze(['44/92']),
  }),
  Object.freeze({
    metaobjectId: '95970099498',
    handle: '102',
    displayName: '102',
    deValues: Object.freeze(['102']),
    inchValues: Object.freeze(['36/36']),
    waist: 91,
    insideLeg: 91,
    belt: Object.freeze({
      cm: '95',
      inch: '36',
    }),
    frEsValues: Object.freeze(['44/92']),
  }),
  Object.freeze({
    metaobjectId: '96072696106',
    handle: '36-30',
    displayName: '36/30',
    deValues: Object.freeze(['25']),
    inchValues: Object.freeze(['36/30']),
    waist: 93,
    insideLeg: 76,
    belt: Object.freeze({
      cm: '95',
      inch: '36',
    }),
    frEsValues: Object.freeze(['46C']),
  }),
  Object.freeze({
    metaobjectId: '96049758506',
    handle: '25',
    displayName: '25',
    deValues: Object.freeze(['25']),
    inchValues: Object.freeze(['36/30']),
    waist: 93,
    insideLeg: 79,
    belt: Object.freeze({
      cm: '95',
      inch: '36',
    }),
    frEsValues: Object.freeze(['46C']),
  }),
  Object.freeze({
    metaobjectId: '96076038442',
    handle: '36-32',
    displayName: '36/32',
    deValues: Object.freeze(['52 • 25']),
    inchValues: Object.freeze(['36/32']),
    waist: 93,
    insideLeg: 81,
    belt: Object.freeze({
      cm: '95',
      inch: '36',
    }),
    frEsValues: Object.freeze(['46/92']),
  }),
  Object.freeze({
    metaobjectId: '96695484714',
    handle: '52-x',
    displayName: '52X',
    deValues: Object.freeze(['52X']),
    inchValues: Object.freeze(['36/32']),
    waist: 93,
    insideLeg: 83,
    belt: Object.freeze({
      cm: '95',
      inch: '36',
    }),
    frEsValues: Object.freeze(['46/92']),
  }),
  Object.freeze({
    metaobjectId: '96053231914',
    handle: '52',
    displayName: '52',
    deValues: Object.freeze(['52']),
    inchValues: Object.freeze(['36/34']),
    waist: 93,
    insideLeg: 85,
    belt: Object.freeze({
      cm: '95',
      inch: '36',
    }),
    frEsValues: Object.freeze(['46']),
  }),
  Object.freeze({
    metaobjectId: '96692928810',
    handle: '36-34',
    displayName: '36/34',
    deValues: Object.freeze(['102 • 52']),
    inchValues: Object.freeze(['36/34']),
    waist: 93,
    insideLeg: 86,
    belt: Object.freeze({
      cm: '95',
      inch: '36',
    }),
    frEsValues: Object.freeze(['46']),
  }),
  Object.freeze({
    metaobjectId: '96692699434',
    handle: '36-36',
    displayName: '36/36',
    deValues: Object.freeze(['102']),
    inchValues: Object.freeze(['36/36']),
    waist: 93,
    insideLeg: 91,
    belt: Object.freeze({
      cm: '95',
      inch: '36',
    }),
    frEsValues: Object.freeze(['46']),
  }),
  Object.freeze({
    metaobjectId: '96693190954',
    handle: '25-5',
    displayName: '25.5',
    deValues: Object.freeze(['25.5']),
    inchValues: Object.freeze(['36/30']),
    waist: 94,
    insideLeg: 77,
    belt: Object.freeze({
      cm: '95',
      inch: '36',
    }),
    frEsValues: Object.freeze([]),
  }),
  Object.freeze({
    metaobjectId: '95970394410',
    handle: '106',
    displayName: '106',
    deValues: Object.freeze(['106']),
    inchValues: Object.freeze(['38/36']),
    waist: 95,
    insideLeg: 92,
    belt: Object.freeze({
      cm: '100',
      inch: '38',
    }),
    frEsValues: Object.freeze(['48']),
  }),
  Object.freeze({
    metaobjectId: '96050348330',
    handle: '26',
    displayName: '26',
    deValues: Object.freeze(['26']),
    inchValues: Object.freeze(['38/30']),
    waist: 97,
    insideLeg: 80,
    belt: Object.freeze({
      cm: '100',
      inch: '38',
    }),
    frEsValues: Object.freeze(['48C']),
  }),
  Object.freeze({
    metaobjectId: '96695517482',
    handle: '54-x',
    displayName: '54X',
    deValues: Object.freeze(['54X']),
    inchValues: Object.freeze(['38/32']),
    waist: 97,
    insideLeg: 83,
    belt: Object.freeze({
      cm: '100',
      inch: '38',
    }),
    frEsValues: Object.freeze(['48/92']),
  }),
  Object.freeze({
    metaobjectId: '96053297450',
    handle: '54',
    displayName: '54',
    deValues: Object.freeze(['54']),
    inchValues: Object.freeze(['38/34']),
    waist: 97,
    insideLeg: 86,
    belt: Object.freeze({
      cm: '100',
      inch: '38',
    }),
    frEsValues: Object.freeze(['48']),
  }),
  Object.freeze({
    metaobjectId: '96072761642',
    handle: '38-30',
    displayName: '38/30',
    deValues: Object.freeze(['26']),
    inchValues: Object.freeze(['38/30']),
    waist: 98,
    insideLeg: 76,
    belt: Object.freeze({
      cm: '100',
      inch: '38',
    }),
    frEsValues: Object.freeze(['48C']),
  }),
  Object.freeze({
    metaobjectId: '96693223722',
    handle: '26-5',
    displayName: '26.5',
    deValues: Object.freeze(['26.5']),
    inchValues: Object.freeze(['38/30']),
    waist: 98,
    insideLeg: 78,
    belt: Object.freeze({
      cm: '100',
      inch: '38',
    }),
    frEsValues: Object.freeze([]),
  }),
  Object.freeze({
    metaobjectId: '96693158186',
    handle: '38-32',
    displayName: '38/32',
    deValues: Object.freeze(['54 • 26']),
    inchValues: Object.freeze(['38/32']),
    waist: 98,
    insideLeg: 81,
    belt: Object.freeze({
      cm: '100',
      inch: '38',
    }),
    frEsValues: Object.freeze(['48/92']),
  }),
  Object.freeze({
    metaobjectId: '96692896042',
    handle: '38-34',
    displayName: '38/34',
    deValues: Object.freeze(['54']),
    inchValues: Object.freeze(['38/34']),
    waist: 98,
    insideLeg: 86,
    belt: Object.freeze({
      cm: '100',
      inch: '38',
    }),
    frEsValues: Object.freeze(['48']),
  }),
  Object.freeze({
    metaobjectId: '96692764970',
    handle: '38-36',
    displayName: '38/36',
    deValues: Object.freeze(['106']),
    inchValues: Object.freeze(['38/36']),
    waist: 98,
    insideLeg: 91,
    belt: Object.freeze({
      cm: '100',
      inch: '38',
    }),
    frEsValues: Object.freeze(['48']),
  }),
  Object.freeze({
    metaobjectId: '96050610474',
    handle: '27',
    displayName: '27',
    deValues: Object.freeze(['27']),
    inchValues: Object.freeze(['40/32']),
    waist: 101,
    insideLeg: 81,
    belt: Object.freeze({
      cm: '105',
      inch: '40',
    }),
    frEsValues: Object.freeze(['50C']),
  }),
  Object.freeze({
    metaobjectId: '95970492714',
    handle: '110',
    displayName: '110',
    deValues: Object.freeze(['110']),
    inchValues: Object.freeze(['40/36']),
    waist: 101,
    insideLeg: 93,
    belt: Object.freeze({
      cm: '105',
      inch: '40',
    }),
    frEsValues: Object.freeze(['50']),
  }),
  Object.freeze({
    metaobjectId: '96693256490',
    handle: '27-5',
    displayName: '27.5',
    deValues: Object.freeze(['27.5']),
    inchValues: Object.freeze(['40/30']),
    waist: 102,
    insideLeg: 79,
    belt: Object.freeze({
      cm: '105',
      inch: '40',
    }),
    frEsValues: Object.freeze([]),
  }),
  Object.freeze({
    metaobjectId: '96695451946',
    handle: '56-x',
    displayName: '56X',
    deValues: Object.freeze(['56X']),
    inchValues: Object.freeze(['40/34']),
    waist: 103,
    insideLeg: 85,
    belt: Object.freeze({
      cm: '105',
      inch: '40',
    }),
    frEsValues: Object.freeze(['50/92']),
  }),
  Object.freeze({
    metaobjectId: '96053330218',
    handle: '56',
    displayName: '56',
    deValues: Object.freeze(['56']),
    inchValues: Object.freeze(['40/34']),
    waist: 103,
    insideLeg: 87,
    belt: Object.freeze({
      cm: '105',
      inch: '40',
    }),
    frEsValues: Object.freeze(['50/52']),
  }),
  Object.freeze({
    metaobjectId: '96072827178',
    handle: '40-30',
    displayName: '40/30',
    deValues: Object.freeze(['27']),
    inchValues: Object.freeze(['40/30']),
    waist: 104,
    insideLeg: 76,
    belt: Object.freeze({
      cm: '110',
      inch: '42',
    }),
    frEsValues: Object.freeze([]),
  }),
  Object.freeze({
    metaobjectId: '96693125418',
    handle: '40-32',
    displayName: '40/32',
    deValues: Object.freeze(['56 • 27']),
    inchValues: Object.freeze(['40/32']),
    waist: 104,
    insideLeg: 81,
    belt: Object.freeze({
      cm: '110',
      inch: '42',
    }),
    frEsValues: Object.freeze(['50C']),
  }),
  Object.freeze({
    metaobjectId: '96692863274',
    handle: '40-34',
    displayName: '40/34',
    deValues: Object.freeze(['56']),
    inchValues: Object.freeze(['40/34']),
    waist: 104,
    insideLeg: 86,
    belt: Object.freeze({
      cm: '110',
      inch: '42',
    }),
    frEsValues: Object.freeze(['50/52']),
  }),
  Object.freeze({
    metaobjectId: '96658915626',
    handle: '40-36',
    displayName: '40/36',
    deValues: Object.freeze(['110']),
    inchValues: Object.freeze(['40/36']),
    waist: 104,
    insideLeg: 91,
    belt: Object.freeze({
      cm: '110',
      inch: '42',
    }),
    frEsValues: Object.freeze(['50']),
  }),
  Object.freeze({
    metaobjectId: '96050807082',
    handle: '28',
    displayName: '28',
    deValues: Object.freeze(['28']),
    inchValues: Object.freeze(['42/32']),
    waist: 107,
    insideLeg: 82,
    belt: Object.freeze({
      cm: '110',
      inch: '42',
    }),
    frEsValues: Object.freeze(['52C/54C']),
  }),
  Object.freeze({
    metaobjectId: '95970591018',
    handle: '114',
    displayName: '114',
    deValues: Object.freeze(['114']),
    inchValues: Object.freeze(['42/36']),
    waist: 107,
    insideLeg: 93,
    belt: Object.freeze({
      cm: '110',
      inch: '42',
    }),
    frEsValues: Object.freeze(['52']),
  }),
  Object.freeze({
    metaobjectId: '96693322026',
    handle: '28-5',
    displayName: '28.5',
    deValues: Object.freeze(['28.5']),
    inchValues: Object.freeze(['42/30']),
    waist: 108,
    insideLeg: 80,
    belt: Object.freeze({
      cm: '110',
      inch: '42',
    }),
    frEsValues: Object.freeze([]),
  }),
  Object.freeze({
    metaobjectId: '96072892714',
    handle: '42-30',
    displayName: '42/30',
    deValues: Object.freeze(['28']),
    inchValues: Object.freeze(['42/30']),
    waist: 109,
    insideLeg: 76,
    belt: Object.freeze({
      cm: '115',
      inch: '44',
    }),
    frEsValues: Object.freeze([]),
  }),
  Object.freeze({
    metaobjectId: '96693092650',
    handle: '42-32',
    displayName: '42/32',
    deValues: Object.freeze(['58 • 28']),
    inchValues: Object.freeze(['42/32']),
    waist: 109,
    insideLeg: 81,
    belt: Object.freeze({
      cm: '115',
      inch: '44',
    }),
    frEsValues: Object.freeze(['52C/54C']),
  }),
  Object.freeze({
    metaobjectId: '96692830506',
    handle: '42-34',
    displayName: '42/34',
    deValues: Object.freeze(['58']),
    inchValues: Object.freeze(['42/34']),
    waist: 109,
    insideLeg: 86,
    belt: Object.freeze({
      cm: '115',
      inch: '44',
    }),
    frEsValues: Object.freeze(['54']),
  }),
  Object.freeze({
    metaobjectId: '96053428522',
    handle: '58',
    displayName: '58',
    deValues: Object.freeze(['58']),
    inchValues: Object.freeze(['42/34']),
    waist: 109,
    insideLeg: 87,
    belt: Object.freeze({
      cm: '115',
      inch: '44',
    }),
    frEsValues: Object.freeze(['54']),
  }),
  Object.freeze({
    metaobjectId: '96050938154',
    handle: '29',
    displayName: '29',
    deValues: Object.freeze(['29']),
    inchValues: Object.freeze(['44/32']),
    waist: 113,
    insideLeg: 83,
    belt: Object.freeze({
      cm: '115',
      inch: '44',
    }),
    frEsValues: Object.freeze(['56C']),
  }),
  Object.freeze({
    metaobjectId: '95975866666',
    handle: '118',
    displayName: '118',
    deValues: Object.freeze(['118']),
    inchValues: Object.freeze(['44/36']),
    waist: 113,
    insideLeg: 94,
    belt: Object.freeze({
      cm: '115',
      inch: '44',
    }),
    frEsValues: Object.freeze(['54']),
  }),
  Object.freeze({
    metaobjectId: '98877767978',
    handle: '44-30',
    displayName: '44/30',
    deValues: Object.freeze([]),
    inchValues: Object.freeze(['44/30']),
    waist: 114,
    insideLeg: 76.5,
    belt: Object.freeze({
      cm: '115',
      inch: '44',
    }),
    frEsValues: Object.freeze(['58/92']),
  }),
  Object.freeze({
    metaobjectId: '96693289258',
    handle: '29-5',
    displayName: '29.5',
    deValues: Object.freeze(['29.5']),
    inchValues: Object.freeze(['44/30']),
    waist: 114,
    insideLeg: 81,
    belt: Object.freeze({
      cm: '115',
      inch: '44',
    }),
    frEsValues: Object.freeze(['58/92']),
  }),
  Object.freeze({
    metaobjectId: '96693059882',
    handle: '44-32',
    displayName: '44/32',
    deValues: Object.freeze(['29']),
    inchValues: Object.freeze(['44/32']),
    waist: 114,
    insideLeg: 81,
    belt: Object.freeze({
      cm: '120',
      inch: '46',
    }),
    frEsValues: Object.freeze(['56C']),
  }),
  Object.freeze({
    metaobjectId: '98877800746',
    handle: '44-34',
    displayName: '44/34',
    deValues: Object.freeze(['56 · 92']),
    inchValues: Object.freeze(['44/34']),
    waist: 114,
    insideLeg: 86.5,
    belt: Object.freeze({
      cm: '115',
      inch: '44',
    }),
    frEsValues: Object.freeze(['58/92']),
  }),
  Object.freeze({
    metaobjectId: '96053592362',
    handle: '60',
    displayName: '60',
    deValues: Object.freeze(['60']),
    inchValues: Object.freeze(['44/34']),
    waist: 115,
    insideLeg: 88,
    belt: Object.freeze({
      cm: '120',
      inch: '46',
    }),
    frEsValues: Object.freeze(['56/58']),
  }),
  Object.freeze({
    metaobjectId: '98877833514',
    handle: '46-30',
    displayName: '46/30',
    deValues: Object.freeze([]),
    inchValues: Object.freeze(['46/30']),
    waist: 119,
    insideLeg: 76.5,
    belt: Object.freeze({
      cm: '125',
      inch: '48',
    }),
    frEsValues: Object.freeze(['58c/92']),
  }),
  Object.freeze({
    metaobjectId: '96051003690',
    handle: '30',
    displayName: '30',
    deValues: Object.freeze(['30']),
    inchValues: Object.freeze(['46/32']),
    waist: 119,
    insideLeg: 83,
    belt: Object.freeze({
      cm: '125',
      inch: '48',
    }),
    frEsValues: Object.freeze(['58C/60C']),
  }),
  Object.freeze({
    metaobjectId: '98877997354',
    handle: '46-32',
    displayName: '46/32',
    deValues: Object.freeze(['31']),
    inchValues: Object.freeze(['46/32']),
    waist: 119,
    insideLeg: 83,
    belt: Object.freeze({
      cm: '125',
      inch: '48',
    }),
    frEsValues: Object.freeze(['58c/92']),
  }),
  Object.freeze({
    metaobjectId: '98855387434',
    handle: '30-5',
    displayName: '30.5',
    deValues: Object.freeze(['30.5']),
    inchValues: Object.freeze(['46/30']),
    waist: 120,
    insideLeg: 80,
    belt: Object.freeze({
      cm: '125',
      inch: '48',
    }),
    frEsValues: Object.freeze(['58c/92']),
  }),
  Object.freeze({
    metaobjectId: '96053657898',
    handle: '62',
    displayName: '62',
    deValues: Object.freeze(['62']),
    inchValues: Object.freeze(['48/34']),
    waist: 121,
    insideLeg: 89,
    belt: Object.freeze({
      cm: '125',
      inch: '48',
    }),
    frEsValues: Object.freeze(['60']),
  }),
  Object.freeze({
    metaobjectId: '98878062890',
    handle: '48-30',
    displayName: '48/30',
    deValues: Object.freeze([]),
    inchValues: Object.freeze(['48/30']),
    waist: 124,
    insideLeg: 76.5,
    belt: Object.freeze({
      cm: '130',
      inch: '50',
    }),
    frEsValues: Object.freeze(['62c/92']),
  }),
  Object.freeze({
    metaobjectId: '96051101994',
    handle: '31',
    displayName: '31',
    deValues: Object.freeze(['31']),
    inchValues: Object.freeze(['48/32']),
    waist: 125,
    insideLeg: 84,
    belt: Object.freeze({
      cm: '130',
      inch: '50',
    }),
    frEsValues: Object.freeze(['58c/92']),
  }),
  Object.freeze({
    metaobjectId: '98878193962',
    handle: '48-32',
    displayName: '48/32',
    deValues: Object.freeze(['32']),
    inchValues: Object.freeze(['48/32']),
    waist: 125,
    insideLeg: 84,
    belt: Object.freeze({
      cm: '130',
      inch: '50',
    }),
    frEsValues: Object.freeze(['62c/92']),
  }),
  Object.freeze({
    metaobjectId: '132388815146',
    handle: '31-5',
    displayName: '31.5',
    deValues: Object.freeze(['31.5']),
    inchValues: Object.freeze(['49/32']),
    waist: 126,
    insideLeg: 81,
    belt: Object.freeze({
      cm: '130',
      inch: '50',
    }),
    frEsValues: Object.freeze(['62c/92']),
  }),
  Object.freeze({
    metaobjectId: '98855616810',
    handle: '64',
    displayName: '64',
    deValues: Object.freeze(['64']),
    inchValues: Object.freeze(['48/34']),
    waist: 127,
    insideLeg: 90,
    belt: Object.freeze({
      cm: '130',
      inch: '50',
    }),
    frEsValues: Object.freeze(['64c/92']),
  }),
  Object.freeze({
    metaobjectId: '98878259498',
    handle: '50-30',
    displayName: '50/30',
    deValues: Object.freeze([]),
    inchValues: Object.freeze(['50/30']),
    waist: 129,
    insideLeg: 76.5,
    belt: Object.freeze({
      cm: '135',
      inch: '52',
    }),
    frEsValues: Object.freeze(['64c/92']),
  }),
  Object.freeze({
    metaobjectId: '96051167530',
    handle: '32',
    displayName: '32',
    deValues: Object.freeze(['32']),
    inchValues: Object.freeze(['50/32']),
    waist: 129,
    insideLeg: 85,
    belt: Object.freeze({
      cm: '135',
      inch: '52',
    }),
    frEsValues: Object.freeze(['64/92']),
  }),
  Object.freeze({
    metaobjectId: '98878292266',
    handle: '50-32',
    displayName: '50/32',
    deValues: Object.freeze(['33']),
    inchValues: Object.freeze(['50/32']),
    waist: 129,
    insideLeg: 85,
    belt: Object.freeze({
      cm: '135',
      inch: '52',
    }),
    frEsValues: Object.freeze(['64c/92']),
  }),
  Object.freeze({
    metaobjectId: '98855649578',
    handle: '66',
    displayName: '66',
    deValues: Object.freeze(['66']),
    inchValues: Object.freeze(['52/34']),
    waist: 133,
    insideLeg: 90,
    belt: Object.freeze({
      cm: '135',
      inch: '52',
    }),
    frEsValues: Object.freeze(['66c/92']),
  }),
  Object.freeze({
    metaobjectId: '98878325034',
    handle: '52-30',
    displayName: '52/30',
    deValues: Object.freeze([]),
    inchValues: Object.freeze(['52/30']),
    waist: 134,
    insideLeg: 76.5,
    belt: Object.freeze({
      cm: '140',
      inch: '54',
    }),
    frEsValues: Object.freeze(['66c/92']),
  }),
  Object.freeze({
    metaobjectId: '96051233066',
    handle: '33',
    displayName: '33',
    deValues: Object.freeze(['33']),
    inchValues: Object.freeze(['52/32']),
    waist: 135,
    insideLeg: 85,
    belt: Object.freeze({
      cm: '140',
      inch: '54',
    }),
    frEsValues: Object.freeze(['64c/92']),
  }),
  Object.freeze({
    metaobjectId: '98855584042',
    handle: '52-32',
    displayName: '52/32',
    deValues: Object.freeze(['33']),
    inchValues: Object.freeze(['52/32']),
    waist: 135,
    insideLeg: 85,
    belt: Object.freeze({
      cm: '140',
      inch: '54',
    }),
    frEsValues: Object.freeze(['66c/92']),
  }),
  Object.freeze({
    metaobjectId: '96051298602',
    handle: '34',
    displayName: '34',
    deValues: Object.freeze(['34']),
    inchValues: Object.freeze(['54/32']),
    waist: 139,
    insideLeg: 86,
    belt: Object.freeze({
      cm: '145',
      inch: '56',
    }),
    frEsValues: Object.freeze(['68C']),
  }),
  Object.freeze({
    metaobjectId: '96051331370',
    handle: '35',
    displayName: '35',
    deValues: Object.freeze(['35']),
    inchValues: Object.freeze(['56/32']),
    waist: 143,
    insideLeg: 86,
    belt: Object.freeze({
      cm: '145',
      inch: '56',
    }),
    frEsValues: Object.freeze(['70C']),
  }),
]);


// src/data/size-calculator-lookup.js

const unique = (values) => [...new Set(values.filter(Boolean))];

const isInchProductSize = (size) => String(size).includes('/');

const getInchLengthGroup = (size) => {
  const [, length] = String(size).split('/');

  switch (length) {
    case '30':
      return 'inch-short';
    case '32':
      return 'inch-regular';
    case '34':
      return 'inch-long';
    case '36':
      return 'inch-extra-long';
    default:
      return 'inch-other';
  }
};

const getEuSizeGroup = (size) => {
  const value = String(size).trim();

  if (value.endsWith('X')) {
    return 'eu-extra';
  }

  const numericValue = Number.parseFloat(value);

  if (!Number.isFinite(numericValue)) {
    return 'eu-other';
  }

  if (numericValue >= 90) {
    return 'eu-tall';
  }

  if (numericValue < 44) {
    return 'eu-stocky';
  }

  return 'eu-regular';
};

const normalizeStringList = (value) => {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value
      .map(String)
      .map((item) => item.trim())
      .filter(Boolean);
  }

  return [String(value).trim()].filter(Boolean);
};

const parseBeltLength = (row) => {
  if (row.belt) {
    return {
      cm: String(row.belt.cm || ''),
      inch: String(row.belt.inch || ''),
    };
  }

  const [cm = '', inch = ''] = String(row.beltLength || '').split('/');

  return {
    cm: cm.trim(),
    inch: inch.trim(),
  };
};

const normalizeSizeRows = (sourceRows = []) =>
  Object.freeze(
    sourceRows
      .filter((row) => {
        const productSize = String(row.displayName || '').trim();
        const waist = Number(row.waist);
        const insideLeg = Number(row.insideLeg);

        return productSize && Number.isFinite(waist) && Number.isFinite(insideLeg);
      })
      .map((row) => {
        const productSize = String(row.displayName).trim();
        const belt = parseBeltLength(row);

        return Object.freeze({
          metaobjectId: String(row.metaobjectId || ''),
          handle: String(row.handle || ''),
          productSize,
          sizeSystem: isInchProductSize(productSize) ? 'inch' : 'eu',
          sizeGroup: isInchProductSize(productSize) ? getInchLengthGroup(productSize) : getEuSizeGroup(productSize),
          waist: Number(row.waist),
          insideLeg: Number(row.insideLeg),
          beltCm: belt.cm,
          beltInch: belt.inch,
          comparableEuSizes: normalizeStringList(row.deValues),
          comparableInchSizes: normalizeStringList(row.inchValues),
          comparableFrEsSizes: normalizeStringList(row.frEsValues),
        });
      }),
  );

const normalizedSizeRows = normalizeSizeRows(sizeCalculatorData);

const getRowsBySystem = (rows, sizeSystem) =>
  rows.filter((row) => row.sizeSystem === sizeSystem && Number.isFinite(row.waist) && Number.isFinite(row.insideLeg));

const compareWithLargerTieBreak = (customerValue, firstValue, secondValue) => {
  const firstDistance = Math.abs(customerValue - firstValue);
  const secondDistance = Math.abs(customerValue - secondValue);

  if (firstDistance !== secondDistance) {
    return firstDistance - secondDistance;
  }

  /*
   * At an exact midpoint, prefer the larger value.
   *
   * For waist measurements this means the roomier size wins.
   * The function is also retained for belt matching below.
   */
  return secondValue - firstValue;
};

const uniqueSortedNumbers = (values) =>
  [...new Set(values)].filter(Number.isFinite).sort((first, second) => first - second);

const getSupportedRange = (values) => {
  const sortedValues = uniqueSortedNumbers(values);

  if (!sortedValues.length) {
    return null;
  }

  if (sortedValues.length === 1) {
    return {
      minimum: sortedValues[0],
      maximum: sortedValues[0],
    };
  }

  const firstGap = sortedValues[1] - sortedValues[0];

  const lastGap = sortedValues[sortedValues.length - 1] - sortedValues[sortedValues.length - 2];

  return {
    minimum: sortedValues[0] - firstGap / 2,
    maximum: sortedValues[sortedValues.length - 1] + lastGap / 2,
  };
};

const isWithinSupportedRange = (value, range) => Boolean(range && value >= range.minimum && value <= range.maximum);

const maximumShorteningAllowanceCm = 5;

const getMaximumTooShortAllowanceCm = (row) => {
  /*
   * Policy C
   *
   * Inch sizes:
   *   maximum 1 cm too short
   *
   * Standard EU sizes:
   *   maximum 1 cm too short
   *
   * EU tall and extra sizes:
   *   maximum 2 cm too short
   *
   * EU regular sizes 60 and above:
   *   maximum 2 cm too short
   */
  if (row.sizeSystem === 'inch') {
    return 1;
  }

  if (row.sizeGroup === 'eu-tall' || row.sizeGroup === 'eu-extra') {
    return 2;
  }

  const numericSize = Number.parseFloat(row.productSize);

  if (row.sizeGroup === 'eu-regular' && Number.isFinite(numericSize) && numericSize >= 60) {
    return 2;
  }

  return 1;
};

const getCandidateMeasurements = (row, waist, insideLeg) => {
  const waistDifference = Math.abs(waist - row.waist);

  const signedLengthDifference = row.insideLeg - insideLeg;

  const absoluteLengthDifference = Math.abs(signedLengthDifference);

  const shorteningBy = Math.max(0, signedLengthDifference);

  const tooShortBy = Math.max(0, -signedLengthDifference);

  return {
    row,
    waistDifference,
    signedLengthDifference,
    absoluteLengthDifference,
    shorteningBy,
    tooShortBy,
  };
};

const isValidCandidate = (candidate) => {
  if (candidate.shorteningBy > maximumShorteningAllowanceCm) {
    return false;
  }

  const maximumTooShortAllowanceCm = getMaximumTooShortAllowanceCm(candidate.row);

  return candidate.tooShortBy <= maximumTooShortAllowanceCm;
};

const compareCandidates = (first, second) => {
  /*
   * 1. Prefer the closest waist.
   */
  if (first.waistDifference !== second.waistDifference) {
    return first.waistDifference - second.waistDifference;
  }

  /*
   * 2. At an exact waist midpoint,
   *    prefer the larger stored waist.
   */
  if (first.row.waist !== second.row.waist) {
    return second.row.waist - first.row.waist;
  }

  /*
   * 3. Prefer the smallest length adjustment.
   */
  if (first.absoluteLengthDifference !== second.absoluteLengthDifference) {
    return first.absoluteLengthDifference - second.absoluteLengthDifference;
  }

  /*
   * 4. At an equal length difference,
   *    prefer trousers that are longer and
   *    can be shortened over trousers that
   *    are already too short.
   *
   * Positive signedLengthDifference means
   * the trousers are longer.
   */
  if (first.signedLengthDifference !== second.signedLengthDifference) {
    return second.signedLengthDifference - first.signedLengthDifference;
  }

  /*
   * 5. Stable final ordering by product size.
   */
  return String(first.row.productSize).localeCompare(String(second.row.productSize), undefined, {
    numeric: true,
  });
};

const findMatchingRows = (rows, sizeSystem, waist, insideLeg) => {
  if (!Number.isFinite(waist) || !Number.isFinite(insideLeg)) {
    return [];
  }

  const systemRows = getRowsBySystem(rows, sizeSystem);

  if (!systemRows.length) {
    return [];
  }

  /*
   * Every row in the sizing system competes.
   * Category-specific Policy C length limits
   * are applied to each row individually.
   */
  const lengthCompatibleCandidates = systemRows
    .map((row) => getCandidateMeasurements(row, waist, insideLeg))
    .filter(isValidCandidate);

  if (!lengthCompatibleCandidates.length) {
    return [];
  }

  /*
   * Keep only candidates whose stored waist
   * differs by no more than 3 cm from the
   * customer's waist.
   */

  const candidates = lengthCompatibleCandidates
    .filter((candidate) => candidate.waistDifference <= 3)
    .sort(compareCandidates);

  if (!candidates.length) {
    return [];
  }

  const bestCandidate = candidates[0];
  const bestRow = bestCandidate.row;

  /*
   * Return every equivalent size row sharing
   * the winning physical measurements.
   *
   * Do not restrict this to the winning
   * category because another category may
   * contain an equivalent display size.
   */
  return systemRows.filter((row) => row.waist === bestRow.waist && row.insideLeg === bestRow.insideLeg);
};

const findClosestBeltRows = (normalizedRows, waist) => {
  if (!Number.isFinite(waist)) {
    return [];
  }

  const beltRows = normalizedRows.filter((row) => Number.isFinite(row.waist) && (row.beltCm || row.beltInch));

  if (!beltRows.length) {
    return [];
  }

  const supportedRange = getSupportedRange(beltRows.map((row) => row.waist));

  if (!isWithinSupportedRange(waist, supportedRange)) {
    return [];
  }

  const sortedRows = [...beltRows].sort((first, second) => compareWithLargerTieBreak(waist, first.waist, second.waist));

  const closestWaist = sortedRows[0].waist;

  return sortedRows.filter((row) => row.waist === closestWaist);
};

const getMostFrequentValue = (values) => {
  const counts = new Map();

  values.filter(Boolean).forEach((value) => {
    counts.set(value, (counts.get(value) || 0) + 1);
  });

  return [...counts.entries()].sort((first, second) => second[1] - first[1]).map(([value]) => value)[0];
};

const createSizeRecommendation = (waist, insideLeg, sourceRows = sizeCalculatorData) => {
  const rows = normalizeSizeRows(sourceRows);

  const euRows = findMatchingRows(rows, 'eu', waist, insideLeg);

  const inchRows = findMatchingRows(rows, 'inch', waist, insideLeg);

  const beltRows = findClosestBeltRows(rows, waist);

  const beltCm = getMostFrequentValue(beltRows.map((row) => row.beltCm));

  const beltInch = getMostFrequentValue(beltRows.map((row) => row.beltInch));

  return {
    euSizes: unique(euRows.map((row) => row.productSize)),
    inchSizes: unique(inchRows.map((row) => row.productSize)),
    beltCm: beltCm ? [beltCm] : [],
    beltInch: beltInch ? [beltInch] : [],
    euRows,
    inchRows,
  };
};

const findClosestSizeRecords = (waist, insideLeg, sourceRows = sizeCalculatorData) => {
  const rows = normalizeSizeRows(sourceRows);

  return {
    euRows: findMatchingRows(rows, 'eu', waist, insideLeg),
    inchRows: findMatchingRows(rows, 'inch', waist, insideLeg),
  };
};


// src/fit-advisor/analytics.js
// Same-tab attribution only. Consent is checked before every read, write or event.
const advisorContextKey = 'meyer_fit_advisor_context_v2';
const advisorContextLifetime = 30 * 60 * 1000;

function advisorAnalyticsAllowed(browser) {
  try { return browser.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true; }
  catch { return false; }
}

function clearAdvisorContext(browser) {
  try { browser.sessionStorage?.removeItem(advisorContextKey); } catch { /* Storage may be blocked. */ }
}

function readAdvisorContext(browser, now = Date.now()) {
  if (!advisorAnalyticsAllowed(browser)) return null;
  try {
    const value = JSON.parse(browser.sessionStorage?.getItem(advisorContextKey) || 'null');
    if (!value || value.advisor_version !== 'v2' || !Number.isFinite(value.updated_at)
      || now < value.updated_at || now - value.updated_at >= advisorContextLifetime) {
      clearAdvisorContext(browser);
      return null;
    }
    return value;
  } catch { return null; }
}

function trackAdvisorEvent(browser, name, detail = {}, now = Date.now()) {
  if (!advisorAnalyticsAllowed(browser)) return false;
  try {
    const role = browser.Shopify?.theme?.role;
    const preview = role ? role !== 'main' : new URLSearchParams(browser.location?.search || '').has('preview_theme_id');
    const context = readAdvisorContext(browser, now) || {
      advisor_used: 0, advisor_quiz_completed: 0, advisor_shop_clicked: 0, advisor_model: '',
    };
    context.advisor_version = 'v2';
    context.advisor_environment = preview ? 'preview' : 'live';
    context.advisor_path = ['model', 'guide', 'size'].includes(detail.path) ? detail.path : context.advisor_path || 'model';
    if (name !== 'view' && name !== 'question_view') context.advisor_used = 1;
    if (name === 'recommendation') context.advisor_quiz_completed = 1;
    if (name === 'shop_click') context.advisor_shop_clicked = 1;
    const model = detail.destination_model || detail.current_model || detail.recommended_model;
    if (model) context.advisor_model = String(model).slice(0, 100);
    context.updated_at = now;
    // Viewing alone does not create an advisor-use attribution record.
    if (context.advisor_used) {
      try { browser.sessionStorage?.setItem(advisorContextKey, JSON.stringify(context)); } catch { /* Events still work. */ }
    }
    const { updated_at, ...parameters } = context;
    const payload = { event: `dl_fit_advisor_${name}`, ...parameters };
    const optional = ['question', 'category', 'fit_preferences', 'design_preferences', 'recommended_model',
      'alternatives', 'result', 'match_count', 'destination_model', 'destination_type', 'current_model',
      'compared_models', 'comparison_count', 'method', 'needs_shortening', 'size_selected', 'model_count'];
    for (const [key, value] of Object.entries(detail)) {
      if (!optional.includes(key)) continue;
      if (Array.isArray(value)) payload[key] = value.join(',').slice(0, 100);
      else if (typeof value === 'string') payload[key] = value.slice(0, 100);
      else if (typeof value === 'boolean' || typeof value === 'number' && Number.isFinite(value)) payload[key] = value;
    }
    // Reset optional fields so GTM's data model cannot inherit a previous event's choices.
    browser.dataLayer = browser.dataLayer || [];
    browser.dataLayer.push({ ...Object.fromEntries(optional.map(key => [key, null])), ...payload });
    return true;
  } catch { return false; /* Analytics must never block shopping or the advisor. */ }
}


// src/fit-advisor/logic.js
const fitFamilies = ['Slim Fit', 'Modern Fit', 'Comfort Fit'];

// Merchant ordering controls browsing only. It never creates a fit match.
function orderModels(models, order = 'alphabetical') {
  const field = order === 'manual' ? 'manualOrder' : 'salesRank';
  const rank = (model) => Number.isInteger(Number(model[field])) && Number(model[field]) > 0
    ? Number(model[field]) : Infinity;
  return [...models].sort((a, b) => {
    if ((order === 'manual' || order === 'sales_rank' || order === true) && rank(a) !== rank(b)) return rank(a) - rank(b);
    return a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' });
  });
}

function currentModels(models) {
  return models.filter((model) => model.currentRange === true);
}

function toggleFitFamily(current, clicked) {
  return current === clicked ? '' : clicked;
}

function matchingModels(models, { family = '', category = '', room = '' } = {}) {
  return models.filter((model) => {
    if (family && model.family !== family) return false;
    if (category && model.category !== category) return false;
    if (room === 'more' && !/room|extra|more/i.test(model.seat)) return false;
    if (room === 'balanced' && !/balanced|regular/i.test(model.seat)) return false;
    if (room === 'closer' && !/closer/i.test(model.seat)) return false;
    return true;
  });
}

// Model relationships always come from the merchant's explicit metaobject references.
function relatedModels(model, models) {
  const byHandle = new Map(models.map((item) => [item.handle, item]));
  return (model?.relations || []).filter((relation) => byHandle.has(relation.handle));
}

function modelShopUrl(collectionUrl, sizes = [], baseUrl = 'https://meyerhosen.myshopify.com') {
  const url = new URL(collectionUrl, baseUrl);
  if (url.origin !== new URL(baseUrl).origin || !url.pathname.includes('/collections/')) return '';
  url.searchParams.delete('filter.v.option.size');
  [...new Set(sizes.map(String).map((size) => size.trim()).filter(Boolean))].forEach((size) => {
    url.searchParams.append('filter.v.option.size', size);
  });
  if (sizes.length) url.searchParams.set('filter.v.availability', '1');
  return url.pathname + url.search + url.hash;
}

function convertStoredSize(rows, displayName) {
  const row = rows.find((item) => String(item.displayName) === String(displayName));
  if (!row) return null;
  return {
    displayName: String(row.displayName),
    eu: [...new Set((row.deValues || []).map(String))],
    inch: [...new Set((row.inchValues || []).map(String))],
    frEs: [...new Set((row.frEsValues || []).map(String))],
    waist: Number(row.waist),
    insideLeg: Number(row.insideLeg),
  };
}

const advisorCategories = ['chino', 'five-pocket', 'cargo', 'shorts', 'golf'];
const advisorFitChoices = ['slimmer', 'balanced', 'roomier', 'waistband'];
const advisorDesignChoices = ['clean', 'pockets'];

function normalizeAdvisorAnswers(answers = {}) {
  const unique = (values, allowed) => [...new Set(Array.isArray(values) ? values.filter((value) => allowed.includes(value)) : [])];
  return {
    category: advisorCategories.includes(answers.category) || answers.category === 'any' ? answers.category : '',
    fit: unique(answers.fit, advisorFitChoices),
    designs: answers.designs?.includes('none') ? [] : unique(answers.designs, advisorDesignChoices),
  };
}

// The existing, merchant-defined fit family is the silhouette classification.
// Seat/thigh descriptions remain explanatory facts, not a duplicate fit profile.
function verifiedFitChoices(model) {
  const choices = { 'Slim Fit': 'slimmer', 'Modern Fit': 'balanced', 'Comfort Fit': 'roomier' };
  return choices[model.family] ? [choices[model.family]] : [];
}

function productCategoryCodes(value) {
  const codes = { Chino: 'chino', 'Swing Pocket': 'chino', 'Five Pocket': 'five-pocket', 'Five-Pocket': 'five-pocket', Cargo: 'cargo', Bermuda: 'shorts', Shorts: 'shorts', 'Shorts / Bermuda': 'shorts', Golf: 'golf' };
  const values = Array.isArray(value) ? value : [value];
  return [...new Set(values.map((item) => codes[item] || (advisorCategories.includes(item) ? item : '')).filter(Boolean))];
}

// Exact values from the existing pocket_style choice list. No model-name rules.
function pocketDesignCodes(value) {
  const choices = {
    'French pockets': 'clean',
    'Five-pocket styling': 'pockets',
    'Swing pockets': 'pockets',
    'Cargo pockets': 'pockets',
  };
  return choices[value] ? [choices[value]] : [];
}

// Descriptions are display copy only; structured pocket choices decide design.
function verifiedDesignChoices(model) {
  return pocketDesignCodes(model.pocketStyle);
}

// Flexible waistbands must be verified on each available article.
function verifiedProductWaistband(product) {
  return product.waistband === true || product.active === true;
}
function evaluateAdvisorModel(model, rawAnswers, { ignoreCategory = false } = {}) {
  const answers = normalizeAdvisorAnswers(rawAnswers);
  if (!model.currentRange || !answers.category || !answers.fit.length) return null;
  const fits = verifiedFitChoices(model);
  const silhouettes = answers.fit.filter((choice) => ['slimmer', 'balanced', 'roomier'].includes(choice));
  const fitMatches = silhouettes.filter((choice) => fits.includes(choice));
  if (silhouettes.length && !fitMatches.length) return null;
  const designs = verifiedDesignChoices(model);
  const designMatches = answers.designs.filter((choice) => designs.includes(choice));
  if (answers.designs.length && !designMatches.length) return null;
  // Chino/cargo describes the construction of some Bermudas too. The explicit
  // Shorts answer keeps those garments out of a long-trouser primary result.
  if (!ignoreCategory && ['chino', 'five-pocket', 'cargo'].includes(answers.category) && model.categories?.includes('shorts')) return null;
  const categoryFits = (product) => {
    const articleCategories = productCategoryCodes(product.category);
    if (['chino', 'five-pocket', 'cargo'].includes(answers.category) && (model.categories?.includes('shorts') || articleCategories.includes('shorts'))) return false;
    const categories = model.categories?.length ? model.categories : articleCategories;
    return categories.includes(answers.category);
  };
  const products = (model.products || []).filter((product) => {
    if (product.available !== true || !product.url?.startsWith('/') || product.url.startsWith('//') || !product.url.includes('/products/')) return false;
    if (!ignoreCategory && answers.category !== 'any' && !categoryFits(product)) return false;
    if (answers.fit.includes('waistband') && !verifiedProductWaistband(product)) return false;
    return true;
  });
  if (!products.length) return null;
  // LOOSE is eligible only for an explicit roomy choice and an exact profile;
  // never a generic comfortable/bestseller fallback or relaxed-category option.
  if (model.handle === 'loose' && (!silhouettes.includes('roomier') || fitMatches.length !== silhouettes.length || designMatches.length !== answers.designs.length || ignoreCategory)) return null;
  return { model, products, fitMatches, designMatches, crossCategory: ignoreCategory && answers.category !== 'any' && !products.some(categoryFits) };
}

// Availability follows the question order. Later preferences must not lock an
// earlier question. Test each OR choice on its own, retaining comfort requirements.
function advisorOptionAvailable(models, rawAnswers, group, value) {
  const answers = normalizeAdvisorAnswers(rawAnswers);
  let candidate;
  if (group === 'category') {
    if (!advisorCategories.includes(value) && value !== 'any') return false;
    candidate = { category: value, fit: ['slimmer', 'balanced', 'roomier'], designs: [] };
  } else if (group === 'fit') {
    if (!advisorFitChoices.includes(value)) return false;
    const silhouettes = ['slimmer', 'balanced', 'roomier'];
    const comfort = answers.fit.filter((choice) => !silhouettes.includes(choice));
    const fits = answers.fit.filter((choice) => silhouettes.includes(choice));
    candidate = { category: answers.category, designs: [], fit: silhouettes.includes(value)
      ? [value, ...comfort] : [...(fits.length ? fits : silhouettes), ...new Set([...comfort, value])] };
  } else if (group === 'design') {
    if (!advisorDesignChoices.includes(value) && value !== 'none') return false;
    candidate = { ...answers, designs: value === 'none' ? [] : [value] };
  } else return false;
  const possibleFits = group === 'category' || group === 'fit' && !answers.fit.some((choice) => ['slimmer', 'balanced', 'roomier'].includes(choice)) && ['waistband'].includes(value)
    ? ['slimmer', 'balanced', 'roomier'].map((fit) => ({ ...candidate, fit: [fit, ...candidate.fit.filter((choice) => ['waistband'].includes(choice))] }))
    : [candidate];
  return possibleFits.some((possible) => models.some((model) => evaluateAdvisorModel(model, possible)));
}

function recommendAdvisorModels(models, rawAnswers, order = 'manual') {
  const answers = normalizeAdvisorAnswers(rawAnswers);
  const eligible = models.map((model) => evaluateAdvisorModel(model, answers)).filter(Boolean);
  const ordering = order === 'sales_rank' ? 'sales_rank' : 'manual';
  const ordered = orderModels(eligible.map((match) => match.model), ordering);
  // A missing/tied merchant order cannot select an alphabetical winner.
  const field = ordering === 'sales_rank' ? 'salesRank' : 'manualOrder';
  const rank = (model) => Number.isInteger(Number(model[field])) && Number(model[field]) > 0 ? Number(model[field]) : Infinity;
  if (!ordered.length) {
    const unverifiedDesign = answers.designs.length && models.some((model) =>
      verifiedDesignChoices(model).length === 0 && evaluateAdvisorModel(model, { ...answers, designs: [] }),
    );
    return { primary: null, alternatives: [], status: unverifiedDesign ? 'incomplete-design-data' : 'no-match' };
  }
  if (ordered.length > 1 && rank(ordered[0]) === rank(ordered[1])) return { primary: null, alternatives: [], status: 'unresolved-order' };
  const primary = eligible.find((match) => match.model.handle === ordered[0].handle);
  const byHandle = new Map(models.map((model) => [model.handle, model]));
  const seen = new Set([primary.model.handle]);
  const alternatives = [];
  // Questionnaire matches come from the customer's answers, not just the
  // primary model's lookup relationships. Show other verified exact matches
  // first, without a results cap, following the existing merchant order.
  for (const model of ordered.slice(1)) {
    const match = eligible.find((candidate) => candidate.model.handle === model.handle);
    if (!match || seen.has(model.handle)) continue;
    seen.add(model.handle);
    alternatives.push(match);
  }
  // Only explicit curated references may provide cross-category alternatives.
  for (const relation of primary.model.relations || []) {
    if (seen.has(relation.handle)) continue;
    seen.add(relation.handle);
    const model = byHandle.get(relation.handle);
    if (!model) continue;
    const match = evaluateAdvisorModel(model, answers) || evaluateAdvisorModel(model, answers, { ignoreCategory: true });
    if (!match || !['slimmer', 'similar', 'roomier', 'extra_1', 'extra_2'].includes(relation.type)) continue;
    alternatives.push({ ...match, relation: relation.type });
  }
  return { primary, alternatives, status: 'matched' };
}


// Article-only construction must not send a customer to the whole model range.
function guideWaistbandPresentation(match) {
  const active = match.products.length > 0 && match.products.every((product) => product.active === true);
  if (active && match.model.activeCollection) return { notice: 'waistband-active', collection: match.model.activeCollection, shopCopy: 'shop-active-model' };
  return { notice: 'waistband-articles', collection: '', shopCopy: '' };
}


// src/fit-advisor/advisor.js

class MeyerFitAdvisor extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const savedGuide = this.readGuideHistory();
    this.restoringGuide = true;
    this.abort = new AbortController();
    this.compare = new Set();
    this.selectedSizes = [];
    this.guideStep = 0;
    this.guideComplete = false;
    const articleEvidence = (card) => {
      try {
        const products = JSON.parse(card.querySelector('[data-guidance-products]')?.textContent || '[]');
        return Array.isArray(products) ? products : [];
      } catch { return []; }
    };
    this.cards = [...this.querySelectorAll('[data-model-catalogue] [data-model-card]')];
    this.models = orderModels(this.cards.map((card) => ({
      handle: card.dataset.handle, name: card.dataset.name,
      family: card.dataset.family, category: card.dataset.category,
      seat: card.dataset.seat, collection: card.dataset.collection,
      length: card.dataset.length, activeCollection: card.dataset.activeModelCollection,
      currentRange: card.dataset.currentRange === 'true', salesRank: card.dataset.salesRank,
      manualOrder: card.dataset.manualOrder,
      categories: productCategoryCodes(card.dataset.category),
      products: articleEvidence(card),
      pocketStyle: card.dataset.pocketStyle,
      searchText: `${card.dataset.name} ${card.dataset.family} ${card.querySelector('[data-model-description]')?.textContent || ''} ${card.querySelector('.mfa-specs')?.textContent || ''}`.toLowerCase(),
      card,
      relations: [...card.querySelectorAll('[data-relation-handle]')].map((item) => ({
        handle: item.dataset.relationHandle, type: item.dataset.relationType, element: item,
      })),
    })), this.dataset.modelOrder);
    this.activeModels = currentModels(this.models);
    const activeHandles = new Set(this.activeModels.map((model) => model.handle));
    const catalogue = this.querySelector('[data-model-catalogue]');
    this.models.forEach((model) => {
      catalogue.append(model.card);
      if (!model.card.querySelector('[data-choose-model]')) {
        const choose = this.querySelector('[data-choose-button]').content.firstElementChild.cloneNode(true);
        choose.dataset.chooseModel = model.handle;
        model.card.querySelector('.mfa-card-actions').append(choose);
      }
      model.card.querySelectorAll('[data-relation-handle]').forEach((item) => {
        item.hidden = !activeHandles.has(item.dataset.relationHandle);
      });
      const relations = model.card.querySelector('[data-relations]');
      relations.hidden = ![...relations.querySelectorAll('li')].some((item) => !item.hidden);
    });
    let rows;
    try { rows = JSON.parse(this.querySelector('[data-size-rows]').textContent); } catch { rows = []; }
    this.rows = Array.isArray(rows) ? rows.filter((row) =>
      row.displayName && Number(row.waist) > 0 && Number(row.insideLeg) > 0,
    ) : [];
    this.querySelectorAll('[data-enhanced]').forEach((node) => { node.hidden = false; });
    this.querySelectorAll('[data-compare-add]').forEach((button) => { button.hidden = false; });

    const select = this.querySelector('[data-current-model]');
    select.length = 1;
    for (const model of orderModels(this.models)) {
      select.add(new Option(model.currentRange ? model.name : `${model.name} (${this.dataset.previousModelLabel})`, model.handle));
    }
    const sizeSelect = this.querySelector('[data-known-size]');
    sizeSelect.length = 1;
    [...new Set(this.rows.map((row) => String(row.displayName)))].sort((a, b) =>
      a.includes('/') - b.includes('/') || a.localeCompare(b, undefined, { numeric: true }),
    ).forEach((size) => sizeSelect.add(new Option(size.includes('/') ? `W/L ${size}` : `EU ${size}`, size)));

    this.addEventListener('click', (event) => this.handleClick(event), { signal: this.abort.signal });
    this.addEventListener('change', (event) => this.handleChange(event), { signal: this.abort.signal });
    this.addEventListener('input', (event) => {
      if (event.target.closest('[data-measure-form]')) this.clearSize();
      if (event.target.matches('[data-model-search]')) this.filterCatalogue();
    }, { signal: this.abort.signal });
    this.querySelector('[data-measure-form]').addEventListener('submit', (event) => this.measure(event), { signal: this.abort.signal });
    window.addEventListener('pageshow', () => {
      const saved = this.readGuideHistory();
      if (saved) this.restoreGuideHistory(saved);
      else this.updateGuideStep();
    }, { signal: this.abort.signal });
    document.addEventListener('visitorConsentCollected', () => {
      if (!advisorAnalyticsAllowed(window)) clearAdvisorContext(window);
      else if (!this.analyticsViewed) this.track('view', { model_count: this.models.length });
    }, { signal: this.abort.signal });
    this.setPath('model');
    this.updateGuideStep();
    const modelParam = new URLSearchParams(location.search).get('model');
    if (this.models.some((model) => model.handle === modelParam)) {
      select.value = modelParam;
      this.selectModel(modelParam);
    }
    this.restoringGuide = false;
    if (savedGuide) this.restoreGuideHistory(savedGuide);
    else this.saveGuideHistory();
    this.track('view', { model_count: this.models.length });
  }

  disconnectedCallback() { this.abort?.abort(); this.ready = false; }

  handleClick(event) {
    if (event.target.closest('[data-guide-next]')) {
      const answers = this.guideAnswers();
      if (this.guideStep === 0 && !answers.category || this.guideStep === 1 && !answers.fit.length) return;
      this.track('question_complete', { path: 'guide', question: this.guideStep + 1, category: answers.category, fit_preferences: answers.fit, design_preferences: answers.designs });
      if (this.guideStep < 2) { this.guideStep++; this.updateGuideStep(true); }
      else this.guide();
    }
    if (event.target.closest('[data-guide-back]')) { this.guideStep = Math.max(0, this.guideStep - 1); this.updateGuideStep(true); }
    if (event.target.closest('[data-guide-skip]')) {
      this.querySelectorAll('[data-guide-answer="design"]').forEach((input) => { input.checked = input.value === 'none'; });
      this.track('question_complete', { path: 'guide', question: 3, design_preferences: [] });
      this.guide();
    }
    if (event.target.closest('[data-guide-edit]')) {
      this.track('edit', { path: 'guide' });
      this.guideComplete = false; this.guideStep = 0;
      this.setPath('guide'); this.updateGuideStep(true);
    }
    if (event.target.closest('[data-guide-restart]')) {
      this.track('restart', { path: 'guide' });
      this.querySelectorAll('[data-guide-answer]').forEach((input) => { input.checked = false; });
      this.guideComplete = false; this.guideStep = 0;
      this.setPath('guide'); this.updateGuideStep(true);
    }
    const familyLink = event.target.closest('[data-fit-family]');
    if (familyLink) {
      event.preventDefault();
      const select = this.querySelector('[data-catalogue-family]');
      select.value = toggleFitFamily(select.value, familyLink.dataset.fitFamily);
      this.querySelector('[data-model-search]').value = '';
      this.filterCatalogue();
      this.querySelector('[data-model-catalogue]').closest('section').scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
    const pathButton = event.target.closest('[data-path]');
    if (pathButton) {
      this.setPath(pathButton.dataset.path);
      this.querySelector(`[data-path-panel="${pathButton.dataset.path}"]`)?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      this.track('start', { path: pathButton.dataset.path });
      if (pathButton.dataset.path === 'guide' && !this.guideComplete) this.track('question_view', { question: this.guideStep + 1 });
    }
    const compareButton = event.target.closest('[data-compare-add]');
    if (compareButton) this.toggleCompare(compareButton.dataset.compareAdd);
    const remove = event.target.closest('[data-compare-remove]');
    if (remove) this.toggleCompare(remove.dataset.compareRemove);
    if (event.target.closest('[data-compare-clear]')) this.clearComparison();
    if (event.target.closest('[data-show-comparison]') && this.compare.size >= 2) {
      this.track('comparison_open', { path: 'model', compared_models: [...this.compare], comparison_count: this.compare.size });
      const comparison = this.querySelector('[data-comparison]');
      comparison.focus({ preventScroll: true });
      comparison.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    const choose = event.target.closest('[data-choose-model]');
    if (choose) {
      this.querySelector('[data-current-model]').value = choose.dataset.chooseModel;
      this.selectModel(choose.dataset.chooseModel);
      this.querySelector('[data-chosen-model]').scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
    const shop = event.target.closest('[data-shop-model]');
    if (shop) this.track('shop_click', { destination_model: shop.dataset.shopModel, destination_type: 'collection', size_selected: this.selectedSizes.length > 0 });
    const guideProduct = event.target.closest('[data-guide-product]');
    if (guideProduct) this.track('shop_click', { destination_model: guideProduct.dataset.guideProduct, path: 'guide', destination_type: 'article' });
    const alternative = event.target.closest('[data-relation-handle], [data-extra-collection]');
    if (alternative && event.target.closest('a[href]') && !shop && !guideProduct) this.track('shop_click', { destination_model: alternative.dataset.relationHandle || '', destination_type: 'alternative_collection' });
    if (event.target.closest('[data-clear-size]')) {
      this.querySelector('[data-measure-form]').reset();
      this.querySelector('[data-known-size]').value = '';
      this.clearSize();
    }
  }

  handleChange(event) {
    if (event.target.matches('[data-guide-answer]')) {
      if (event.target.dataset.guideAnswer === 'design') {
        const noPreference = this.querySelector('[data-guide-answer="design"][value="none"]');
        if (event.target === noPreference && event.target.checked) this.querySelectorAll('[data-guide-answer="design"]').forEach((input) => { if (input !== noPreference) input.checked = false; });
        else if (event.target.checked) noPreference.checked = false;
      }
      const group = event.target.dataset.guideAnswer;
      // A changed earlier answer starts the later questions afresh.
      this.querySelectorAll('[data-guide-answer]').forEach((input) => {
        if (group === 'category' && input.dataset.guideAnswer !== 'category' || group === 'fit' && input.dataset.guideAnswer === 'design') input.checked = false;
      });
      this.guideComplete = false;
      this.updateGuideStep();
    }
    if (event.target.matches('[data-current-model]')) this.selectModel(event.target.value);
    if (event.target.matches('[data-catalogue-family]')) this.filterCatalogue();
    if (event.target.matches('[data-known-size]')) this.knownSize(event.target.value);
  }

  setPath(path) {
    this.activePath = path;
    this.querySelectorAll('.mfa-path[data-path]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.path === path)));
    this.querySelectorAll('[data-path-panel]').forEach((panel) => { panel.hidden = panel.dataset.pathPanel !== path; });
    const sizePath = path === 'size';
    const guidePath = path === 'guide';
    const hideComparison = path !== 'model';
    this.querySelector('[data-model-result]').hidden = sizePath || guidePath || !this.selectedModel;
    this.querySelector('[data-size-result-panel]').hidden = !sizePath || !this.selectedSizes.length;
    this.querySelector('[data-fit-overview]').hidden = sizePath || guidePath;
    this.querySelector('.mfa-catalogue').hidden = sizePath || guidePath;
    this.querySelector('[data-compare-message]').hidden = hideComparison;
    this.querySelector('[data-comparison]').hidden = hideComparison || this.compare.size < 2;
    this.querySelector('[data-compare-launch]').hidden = hideComparison || this.compare.size === 0;
    this.querySelector('[data-catalogue-family-field]').hidden = false;
    this.querySelector('.mfa-catalogue-controls').classList.remove('mfa-fields--one');
    this.querySelectorAll('[data-model-catalogue] [data-choose-model]').forEach((button) => { button.hidden = path !== 'guide'; });
    this.querySelector('[data-catalogue-heading]').textContent = path === 'guide' ? this.dataset.matchesLabel : this.dataset.catalogueLabel;
    this.filterCatalogue();
    this.saveGuideHistory();
  }

  selectModel(handle) {
    this.selectedModel = this.models.find((model) => model.handle === handle);
    const container = this.querySelector('[data-chosen-model]');
    container.replaceChildren();
    const alternatives = this.querySelector('[data-approved-alternatives]');
    alternatives.replaceChildren();
    this.querySelector('[data-model-result]').hidden = this.activePath === 'size' || !this.selectedModel;
    this.querySelector('[data-current-fit-name]').textContent = this.selectedModel?.name || '';
    if (!this.selectedModel) return;
    container.append(this.cloneCard(this.selectedModel));
    relatedModels(this.selectedModel, this.activeModels).forEach((relation) => alternatives.append(relation.element.cloneNode(true)));
    // Preserve curated collection recommendations as well as model recommendations.
    this.selectedModel.card.querySelectorAll('[data-extra-collection][data-current-range="true"]').forEach((item) => alternatives.append(item.cloneNode(true)));
    alternatives.dataset.alternativeCount = String(alternatives.children.length);
    this.querySelector('[data-no-alternatives]').hidden = alternatives.children.length > 0;
    this.querySelector('[data-size-shorts-note]').hidden = this.selectedModel.length !== 'shorts';
    this.refreshShopLinks();
    if (!this.restoringGuide) this.track('model_select', { current_model: handle });
  }

  cloneCard(model) {
    const clone = model.card.cloneNode(true);
    clone.removeAttribute('id');
    clone.removeAttribute('data-shopify-editor-block');
    clone.querySelector('[data-guidance-products]')?.remove();
    clone.hidden = false;
    clone.querySelector('[data-relations]')?.remove();
    clone.querySelector('[data-compare-add]')?.remove();
    clone.querySelector('[data-choose-model]')?.remove();
    return clone;
  }

  copy(key) { return this.dataset[`copy${key.split('-').map((part) => part[0].toUpperCase() + part.slice(1)).join('')}`] || ''; }

  guideAnswers() {
    const selected = (group) => [...this.querySelectorAll(`[data-guide-answer="${group}"]:checked`)].map((input) => input.value);
    return normalizeAdvisorAnswers({ category: selected('category')[0], fit: selected('fit'), designs: selected('design') });
  }

  readGuideHistory() {
    try { return window.history.state?.meyerFitAdvisors?.[this.id] || null; }
    catch { return null; }
  }

  saveGuideHistory() {
    if (this.restoringGuide) return;
    try {
      const previous = window.history.state || {};
      window.history.replaceState({ ...previous, meyerFitAdvisors: {
        ...previous.meyerFitAdvisors,
        [this.id]: { answers: this.guideAnswers(), step: this.guideStep, complete: this.guideComplete, path: this.activePath },
      } }, '');
    } catch { /* Restricted history must not prevent the quiz from working. */ }
  }

  restoreGuideHistory(saved) {
    this.restoringGuide = true;
    const answers = normalizeAdvisorAnswers(saved.answers);
    this.querySelectorAll('[data-guide-answer]').forEach((input) => {
      const group = input.dataset.guideAnswer;
      input.checked = group === 'category' ? input.value === answers.category
        : group === 'fit' ? answers.fit.includes(input.value)
        : input.value === 'none' ? answers.designs.length === 0 : answers.designs.includes(input.value);
    });
    this.guideStep = Number.isInteger(saved.step) ? Math.max(0, Math.min(2, saved.step)) : 0;
    this.guideComplete = false;
    if (saved.complete && answers.category && answers.fit.length) this.guide({ restoring: true });
    else this.updateGuideStep();
    this.setPath(['model', 'guide', 'size'].includes(saved.path) ? saved.path : 'guide');
    this.restoringGuide = false;
    this.saveGuideHistory();
  }

  updateGuideOptions() {
    const answers = this.guideAnswers();
    this.querySelectorAll('[data-guide-answer]').forEach((input) => {
      // Keep selected answers removable, including after a catalogue change.
      input.disabled = !input.checked && !advisorOptionAvailable(this.models, answers, input.dataset.guideAnswer, input.value);
      input.closest('label').classList.toggle('mfa-answer--unavailable', input.disabled);
    });
  }

  updateGuideStep(focus = false) {
    this.updateGuideOptions();
    this.querySelector('[data-guide-questions]').hidden = this.guideComplete;
    this.querySelector('[data-guide-results]').hidden = !this.guideComplete;
    this.querySelectorAll('[data-guide-step]').forEach((step) => { step.hidden = Number(step.dataset.guideStep) !== this.guideStep; });
    this.querySelector('[data-guide-step-number]').textContent = String(this.guideStep + 1);
    this.querySelector('[data-guide-back]').hidden = this.guideStep === 0;
    this.querySelector('[data-guide-skip]').hidden = this.guideStep !== 2;
    const next = this.querySelector('[data-guide-next]');
    const answers = this.guideAnswers();
    next.disabled = this.guideStep === 0 && !answers.category || this.guideStep === 1 && !answers.fit.length;
    next.textContent = this.copy(this.guideStep === 2 ? 'guide-finish' : 'guide-next');
    this.saveGuideHistory();
    if (focus) {
      this.querySelector(`[data-guide-step="${this.guideStep}"] legend`).focus({ preventScroll: true });
      this.querySelector('[data-path-panel="guide"]').scrollIntoView({ block: 'start', behavior: 'smooth' });
      this.track('question_view', { question: this.guideStep + 1 });
    }
  }

  guideCard(match, answers) {
    const card = this.cloneCard(match.model);
    card.querySelector('[data-model-description]')?.remove();
    card.querySelector('.mfa-style')?.remove();
    const actions = card.querySelector('.mfa-card-actions');
    const shopModel = actions.querySelector('[data-shop-model]');
    actions.replaceChildren();
    let showShopModel = !answers.fit.includes('waistband');
    if (answers.fit.includes('waistband')) {
      const presentation = guideWaistbandPresentation(match);
      const notice = document.createElement('p'); notice.className = 'mfa-waistband-notice';
      notice.textContent = this.copy(presentation.notice);
      card.insertBefore(notice, actions);
      if (shopModel && presentation.collection) {
        showShopModel = true;
        shopModel.dataset.shopCollection = presentation.collection;
        shopModel.dataset.shopCopy = presentation.shopCopy;
        shopModel.href = modelShopUrl(presentation.collection, [], location.origin);
        const shopLabel = shopModel.querySelector('[data-shop-label]');
        if (shopLabel) shopLabel.textContent = this.copy(presentation.shopCopy).replace('{model}', match.model.name);
      } else if (shopModel) {
        // With no verified collection target, use the exact qualifying articles.
        shopModel.remove();
      }
    }
    if (shopModel && showShopModel) actions.append(shopModel);
    const explanation = document.createElement('details'); explanation.className = 'mfa-guide-details';
    const heading = document.createElement('summary'); heading.textContent = this.copy('guide-why');
    const reasons = document.createElement('ul'); reasons.className = 'mfa-guide-reasons';
    const add = (text) => { const item = document.createElement('li'); item.textContent = text; reasons.append(item); };
    const label = (group, value) => this.querySelector(`[data-guide-answer="${group}"][value="${value}"]`)?.closest('label').querySelector('.mfa-answer-title').textContent || '';
    if (answers.category !== 'any') add(this.copy(match.crossCategory ? 'reason-other-category' : 'reason-category'));
    if (match.relation) add(this.copy('reason-curated'));
    match.fitMatches.forEach((fit) => add(`${this.copy('reason-fit')} ${label('fit', fit)}`));
    match.designMatches.forEach((design) => add(`${this.copy('reason-design')} ${label('design', design)}`));
    if (answers.fit.includes('waistband')) add(this.copy('reason-waistband'));
    explanation.append(heading, reasons); card.insertBefore(explanation, actions);
    const products = document.createElement('details'); products.className = 'mfa-guide-products mfa-guide-details';
    const title = document.createElement('summary'); title.textContent = `${this.copy('guide-products')} (${match.products.length})`; products.append(title);
    if (answers.fit.includes('waistband')) {
      const note = document.createElement('p'); note.className = 'mfa-note'; note.textContent = this.copy('guide-products-note'); products.append(note);
    }
    const list = document.createElement('ul');
    const addProduct = (product, target) => {
      const item = document.createElement('li'); const link = document.createElement('a');
      link.className = 'mfa-link'; link.href = product.url; link.textContent = product.title;
      link.dataset.guideProduct = match.model.handle; item.append(link); target.append(item);
    };
    match.products.slice(0, 4).forEach((product) => addProduct(product, list));
    products.append(list); actions.append(products);
    if (match.products.length > 4) {
      const more = document.createElement('details'); more.className = 'mfa-measure';
      const summary = document.createElement('summary'); summary.textContent = `${this.copy('guide-more-products')} (${match.products.length - 4})`;
      const rest = document.createElement('ul'); match.products.slice(4).forEach((product) => addProduct(product, rest));
      more.append(summary, rest); products.append(more);
    }
    return card;
  }

  guide({ restoring = false } = {}) {
    const answers = this.guideAnswers();
    this.guideRecommendation = recommendAdvisorModels(this.models, answers, this.dataset.modelOrder);
    const { primary, alternatives, status } = this.guideRecommendation;
    this.querySelector('[data-guide-result-heading]').textContent = this.copy(primary ? 'guide-primary' : 'guide-results');
    this.querySelector('[data-guide-primary]').replaceChildren(...(primary ? [this.guideCard(primary, answers)] : []));
    this.querySelector('[data-guide-alternatives]').replaceChildren(...alternatives.map((match) => this.guideCard(match, answers)));
    this.querySelector('[data-guide-alternatives-panel]').hidden = alternatives.length === 0;
    const noMatch = this.querySelector('[data-guide-no-match]');
    noMatch.hidden = Boolean(primary); noMatch.textContent = this.copy(status === 'unresolved-order' ? 'guide-tie' : status === 'incomplete-design-data' ? 'guide-design-unverified' : 'guide-no-match');
    this.guideComplete = true;
    this.updateGuideStep(); this.setPath('guide'); this.refreshShopLinks();
    if (!restoring) {
      this.querySelector('[data-guide-result-heading]').focus({ preventScroll: true });
      this.querySelector('[data-guide-results]').scrollIntoView({ block: 'start', behavior: 'smooth' });
      this.track('recommendation', { category: answers.category, fit_preferences: answers.fit, design_preferences: answers.designs, recommended_model: primary?.model.handle || '', alternatives: alternatives.map((match) => match.model.handle), result: status, match_count: primary ? alternatives.length + 1 : 0 });
    }
  }

  filterCatalogue() {
    const query = this.querySelector('[data-model-search]').value.trim().toLowerCase();
    const preferences = { family: this.querySelector('[data-catalogue-family]').value };
    const matches = new Set(matchingModels(this.activeModels, preferences).map((model) => model.handle));
    let count = 0;
    for (const model of this.models) {
      model.card.hidden = !matches.has(model.handle) || !model.searchText.includes(query);
      if (!model.card.hidden) count++;
    }
    this.querySelector('[data-result-count]').textContent = String(count);
    this.querySelector('[data-catalogue-empty]').hidden = count > 0;
    this.querySelector('[data-guide-empty]').hidden = true;
    this.querySelectorAll('[data-fit-family]').forEach((link) => {
      if (link.dataset.fitFamily === preferences.family) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  }

  clearComparison() {
    const first = [...this.compare][0];
    const focusTarget = first && this.querySelector(`[data-model-catalogue] [data-compare-add="${first}"]`);
    [...this.compare].forEach((handle) => this.toggleCompare(handle));
    // The clearing control disappears with the empty comparison. Keep keyboard
    // focus on an available model control without moving the customer’s scroll.
    focusTarget?.focus({ preventScroll: true });
  }

  toggleCompare(handle) {
    if (!this.activeModels.some((model) => model.handle === handle)) return;
    if (this.compare.has(handle)) this.compare.delete(handle);
    else if (this.compare.size < 3) this.compare.add(handle);
    else {
      this.querySelector('[data-compare-message]').textContent = this.dataset.compareLimit;
      return;
    }
    this.querySelector('[data-compare-message]').textContent = '';
    this.querySelectorAll('[data-compare-add]').forEach((button) => {
      const selected = this.compare.has(button.dataset.compareAdd);
      button.setAttribute('aria-pressed', String(selected));
      button.querySelector('[data-compare-label]').textContent = selected ? this.dataset.removeLabel : this.dataset.compareLabel;
    });
    const models = [...this.compare].map((handle) => this.models.find((model) => model.handle === handle));
    const head = this.querySelector('[data-comparison-head]');
    head.replaceChildren(head.firstElementChild);
    for (const model of models) {
      const cell = document.createElement('th');
      cell.scope = 'col';
      const card = this.cloneCard(model);
      card.querySelector('.mfa-specs')?.remove();
      card.querySelector('[data-model-description]')?.remove();
      card.querySelector('.mfa-style')?.remove();
      card.querySelector('.mfa-card-actions')?.remove();
      const remove = document.createElement('button');
      remove.type = 'button'; remove.className = 'mfa-remove';
      remove.dataset.compareRemove = model.handle;
      remove.textContent = `${this.dataset.removeLabel} ${model.name}`;
      card.append(remove);
      cell.append(card);
      head.append(cell);
    }
    this.querySelectorAll('[data-compare-spec]').forEach((row) => {
      row.replaceChildren(row.firstElementChild);
      let hasDetail = false;
      for (const model of models) {
        const source = row.dataset.compareSpec === 'description'
          ? model.card.querySelector('[data-model-description]')
          : model.card.querySelector(`[data-spec="${row.dataset.compareSpec}"] dd`);
        const value = source?.textContent.trim();
        const cell = document.createElement('td');
        cell.textContent = value || '—';
        if (value) hasDetail = true;
        row.append(cell);
      }
      row.hidden = !hasDetail;
    });
    const shops = this.querySelector('[data-comparison-shops]');
    shops.replaceChildren(shops.firstElementChild);
    for (const model of models) {
      const cell = document.createElement('td');
      const link = model.card.querySelector('[data-shop-model]');
      if (link) cell.append(link.cloneNode(true));
      shops.append(cell);
    }
    this.querySelector('[data-comparison]').hidden = this.activePath !== 'model' || this.compare.size < 2;
    this.querySelector('[data-compare-launch]').hidden = this.activePath !== 'model' || this.compare.size === 0;
    this.querySelector('[data-compare-selection]').textContent = models.map((model) => model.name).join(' · ');
    this.querySelector('[data-compare-more]').hidden = this.compare.size >= 2;
    this.querySelector('[data-show-comparison]').hidden = this.compare.size < 2;
    this.querySelector('[data-compare-launch-count]').textContent = String(this.compare.size);
    this.querySelector('[data-compare-count]').textContent = String(this.compare.size);
    this.refreshShopLinks();
    this.track('compare', { path: 'model', compared_models: [...this.compare], comparison_count: this.compare.size });
  }

  knownSize(displayName) {
    this.clearSize();
    const result = convertStoredSize(this.rows, displayName);
    if (!result) return;
    this.selectedSizes = [...new Set([displayName, ...result.eu, ...result.inch])];
    const values = [result.eu.length ? `EU ${result.eu.join(' / ')}` : '', result.inch.length ? `W/L ${result.inch.join(' / ')}` : '', result.frEs.length ? `FR/ES ${result.frEs.join(' / ')}` : ''].filter(Boolean);
    const output = this.querySelector('[data-size-result]');
    output.textContent = values.join(' · ') || displayName;
    this.querySelector('[data-size-result-panel]').hidden = false;
    this.querySelector('[data-measure-form]').reset();
    this.refreshShopLinks();
    this.track('size_result', { path: 'size', method: 'stored_conversion' });
  }

  measure(event) {
    event.preventDefault();
    this.clearSize();
    if (!this.rows.length) {
      this.querySelector('[data-size-error]').textContent = this.dataset.sizeDataMissing;
      this.querySelector('[data-size-error]').hidden = false;
      return;
    }
    const form = new FormData(event.target);
    const multiplier = form.get('unit') === 'inch' ? 2.54 : 1;
    const waist = Math.round(Number(form.get('waist')) * multiplier * 10) / 10;
    const insideLeg = Math.round(Number(form.get('inside_leg')) * multiplier * 10) / 10;
    const result = createSizeRecommendation(waist, insideLeg, this.rows);
    this.selectedSizes = [...result.euSizes, ...result.inchSizes];
    this.querySelector('[data-known-size]').value = '';
    if (!this.selectedSizes.length) {
      this.querySelector('[data-size-error]').textContent = this.dataset.noSize;
      this.querySelector('[data-size-error]').hidden = false;
      return;
    }
    const values = [result.euSizes.length ? `EU ${result.euSizes.join(' / ')}` : '', result.inchSizes.length ? `W/L ${result.inchSizes.join(' / ')}` : ''].filter(Boolean);
    this.querySelector('[data-size-result]').textContent = values.join(' · ');
    const adjustments = [...result.euRows, ...result.inchRows];
    const shorten = adjustments.some((row) => row.insideLeg - insideLeg > 2);
    const short = adjustments.some((row) => row.insideLeg < insideLeg);
    this.querySelector('[data-size-adjustment]').textContent = [shorten ? this.dataset.shortening : '', short ? this.dataset.shortLength : ''].filter(Boolean).join(' ');
    this.querySelector('[data-size-result-panel]').hidden = false;
    this.refreshShopLinks();
    // Body measurements are intentionally excluded from analytics.
    this.track('size_result', { path: 'size', method: 'measurement', needs_shortening: shorten });
  }

  clearSize() {
    this.selectedSizes = [];
    this.querySelector('[data-size-result-panel]').hidden = true;
    this.querySelector('[data-size-result]').textContent = '';
    this.querySelector('[data-size-adjustment]').textContent = '';
    this.querySelector('[data-size-error]').hidden = true;
    this.refreshShopLinks();
  }

  refreshShopLinks() {
    this.querySelectorAll('[data-shop-model]').forEach((link) => {
      const model = this.models.find((model) => model.handle === link.dataset.shopModel);
      if (!model?.collection) return;
      // Shorts keep waist-only chart equivalents; trouser inseam is not a shorts length.
      // Missing garment classification cannot establish a safe trouser/shorts conversion.
      const sizes = model.length === 'unknown' ? [] : model.length === 'shorts' ? this.selectedSizes.filter((size) => !size.includes('/')) : this.selectedSizes;
      link.href = modelShopUrl(link.dataset.shopCollection || model.collection, sizes, location.origin);
      const label = link.querySelector('[data-shop-label]');
      if (label) label.textContent = link.dataset.shopCopy ? this.copy(link.dataset.shopCopy).replace('{model}', model.name) : sizes.length ? this.dataset.shopSizeLabel : this.dataset.shopLabel;
    });
  }

  track(name, detail = {}) {
    if (trackAdvisorEvent(window, name, { path: this.activePath || 'model', ...detail }) && name === 'view') this.analyticsViewed = true;
  }
}

if (!customElements.get('meyer-fit-advisor')) customElements.define('meyer-fit-advisor', MeyerFitAdvisor);
